import retrieveDaqsJson from './retrieve-daqs-json'
import tableAdapter from './tableAdapter'
import regions from './filters/regions'
import measures from './filters/measures'
import { components } from '@datavue/datavue-ui'
const HorizontalBarchart = () =>
  import('../components/charts/HorizontalBarchart')
const GenericPage = () => import('@/components/pages/GenericPage')
const DaqsChart = () => import('@/components/DaqsChart')

export default class ParticipationPerson {
  title = 'U.S. Population Participation in Recreational Boating'
  key = 'participation_person'
  pageComponent = GenericPage
  retrieveData = retrieveDaqsJson
  filters = function () {
    return {
      filter1region: {
        label: 'Region:',
        component: components['DatavueUiSelect'],
        options: regions
      },
      measure: {
        label: 'Display Results as:',
        component: components['DatavueUiRadioGroup'],
        props: {
          inline: true
        },
        options: measures
      }
    }
  }
  charts = function () {
    return {
      overall_went_boating: {
        title: 'Boaters That Went Recreational Boating',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      overall_average_days_boating: {
        title: 'Days Spent Recreational Boating',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall',
          average: true
        }
      },
      age_boater: {
        title: 'Boaters By Age',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          tableAdapter: tableAdapter,
          xAxis: {
            series: [
              {
                xAxisKey: 'Under 17',
                yAxisKey: 'label'
              },

              {
                xAxisKey: '18-44',
                yAxisKey: 'label'
              },
              {
                xAxisKey: '45-64',
                yAxisKey: 'label'
              },
              {
                xAxisKey: '65 and Over',
                yAxisKey: 'label'
              }
            ]
          },
          yAxis: { key: 'label' }
        }
      },
      gender_boater: {
        title: 'Boaters By Gender',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          tableAdapter: tableAdapter,
          xAxis: {
            series: [
              {
                xAxisKey: 'Male',
                yAxisKey: 'label'
              },

              {
                xAxisKey: 'Female',
                yAxisKey: 'label'
              }
            ]
          },
          yAxis: { key: 'label' }
        }
      },
      race_boater: {
        title: 'Boaters By Race',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          tableAdapter: tableAdapter,
          xAxis: {
            series: [
              {
                xAxisKey: 'White',
                yAxisKey: 'label'
              },

              {
                xAxisKey: 'Black/AA',
                yAxisKey: 'label'
              },
              {
                xAxisKey: 'Other',
                yAxisKey: 'label'
              }
            ]
          },
          yAxis: { key: 'label' }
        }
      },
      ethnicity_boater: {
        title: 'Boaters By Ethnicity',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          tableAdapter: tableAdapter,
          xAxis: {
            series: [
              {
                xAxisKey: 'Hispanic or Latino',
                yAxisKey: 'label'
              },

              {
                xAxisKey: 'Not Hispanic or Latino',
                yAxisKey: 'label'
              }
            ]
          },
          yAxis: { key: 'label' }
        }
      },
      activities_boater: {
        title: 'Boaters By Activity',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other'
        }
      },
      safety_course_boater: {
        title: 'Boaters That Took Safety Course',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other'
        }
      },
      safety_course_days: {
        title: 'Days Boated By Safety Course Attendance',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          average: true
        }
      }
    }
  }
}
